import { Button } from "antd";
import type { ColumnsType } from "antd/es/table";
import { FormConfigType } from "../../../components/editForm";
import { langPage, langCommon, langTableColumns } from "../../../locales";

const lang = langPage?.member?.role;


export const generateTableColumns = (props: any): ColumnsType => {
    const { operationRef, privilegeRef } = props;

    return [
        {
            title: lang?.id,
            dataIndex: "Id",
        },
        {
            title: lang?.roleName,
            dataIndex: "Name",
        },
        {
            title: langTableColumns?.operation,
            dataIndex: "ops",
            width: 160,
            fixed: "right",
            render: (_: any, row: any) => {
                return (
                    <div>
                        <Button size="small" type="link" className="pdl0"
                            onClick={() => operationRef?.current?.changeVisible(row, 'modify')}
                        >{langCommon?.modify}</Button>
                        <Button size="small" type="link" className="pdl0"
                            onClick={() => privilegeRef?.current?.changeVisible(row)}
                        >分配权限</Button>
                        {/* <Popconfirm title={langCommon?.deleteItem} onConfirm={() => deleteData?.({ Id: row.Id })} >
                            <Button size="small" type="link" loading={loading} className="pdl0 pdr0">{langCommon?.delete}</Button>
                        </Popconfirm> */}
                    </div>
                )
            }
        }
    ]
}

export const generateOperationFormConfig = (props: any): FormConfigType | any => {
    return [
        {
            title: lang?.roleName,
            type: "input",
            field: "Name",
            allowClear: true,
            rules: [{
                required: true,
                message: `${langCommon?.pleaseInput} ${lang?.roleName}`
            }]
        },
    ];
}